import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import ManagePaymentMethods from "Payments/ManagePaymentMethods";
import { motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";

import {
  editModalPanels,
  useRecurringGifts,
} from "../../RecurringGiftsContext";
import { useAmount, useUpdateAddOnAmounts } from "../EditPanel/stateHooks";

export default function PaymentMethodsPanel() {
  const { state, dispatch } = useRecurringGifts();
  const {
    paymentMethods,
    userData,
    wePayData,
    networkName,
    isACHAllowed,
    isCardAllowed,
  } = state.editModal.giftDetails;

  const { paymentType } = state.editModal.currentGift;
  const [amount] = useAmount();
  const updateAddOnAmounts = useUpdateAddOnAmounts();
  const [paymentPageDataIsReady, setPaymentPageDataIsReady] = useState(false);

  useEffect(() => {
    if (!window.data.paymentPageData && wePayData) {
      window.data.paymentPageData = {
        ...wePayData,
        fund: {
          paymentPageSettings: {
            paymentType: paymentType,
          },
        },
      };
      setPaymentPageDataIsReady(true);
    } else if (window.data.paymentPageData) {
      setPaymentPageDataIsReady(true);
    }
  }, [wePayData, paymentType]);

  const handleBackClick = () => {
    dispatch({
      type: "setCurrentPanel",
      payload: editModalPanels.edit,
    });
  };

  const getTitleNoun = () => {
    const hasCards = paymentMethods?.some((pm) => pm.paymentType === "card");
    const hasBanks = paymentMethods?.some((pm) => pm.paymentType === "bank");

    if (hasCards && hasBanks) return "payment method";
    else if (!hasCards && !hasBanks) return "payment method";
    else if (!hasBanks) return "card";
    else return "account";
  };

  const handleCardSelect = (selectedCard) => {
    const { giftWithEdits, editPanelValidationError } = state.editModal;
    dispatch({
      type: "setGiftWithEdits",
      payload: {
        ...giftWithEdits,
        paymentMethod: selectedCard,
      },
    });

    if (editPanelValidationError === "paymentMethod") {
      dispatch({ type: "clearEditPanelValidationError" });
    }

    updateAddOnAmounts({
      newAmount: amount,
      newPaymentType: selectedCard.paymentType,
    });
    handleBackClick();
  };

  const handleExternalUpdate = (data) => {
    // This can be used when after WePay upates/tokenizes
    const { giftWithEdits } = state.editModal;
    const selectedCard = data.find(
      (c) => c.ID && c.ID === giftWithEdits?.paymentMethod?.ID
    );
    if (selectedCard) {
      dispatch({
        type: "setGiftWithEdits",
        payload: {
          ...giftWithEdits,
          paymentMethod: selectedCard,
        },
      });
    }
  };

  if (!paymentPageDataIsReady) return null;

  return (
    <Wrapper>
      <Header>
        <BackButton
          // whileHover={{ scale: 1.05, color: fundColorSafe }}
          // whileTap={{ scale: 0.98, color: fundColorSafe }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleBackClick}
        >
          <FnrIcon fas fa-chevron-circle-left />
        </BackButton>
        <Title>{`Select the ${getTitleNoun()} you'd like to use`}</Title>
      </Header>
      {paymentPageDataIsReady && (
        <ManagePaymentMethods
          onBackClick={handleBackClick}
          onCardSelect={handleCardSelect}
          updateExternalPaymentMethods={handleExternalUpdate}
          initialPaymentMethods={paymentMethods || []}
          initialUserData={userData}
          showQuickControls={false}
          show={true}
          tabID={null}
          networkName={networkName}
          userID={state.profileUserID}
          forceIsCardAllowed={isCardAllowed}
          forceIsACHAllowed={isACHAllowed}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
  position: relative;
  z-index: 1000;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
  max-width: 300px;
  color: var(--fundColor);
`;

const BackButton = styled(motion.div)`
  font-size: 32px;
  cursor: pointer;
  color: #828c8d;
  flex-shrink: 0;
  flex-grow: 0;
`;
